import { LegalClientFirstHeadEntity } from 'api/types/entity';
import { formatToDate } from 'helpers';
import { TFunc } from 'libs/i18n';
import { LegalClientHeadType } from 'modules/client/common/forms/legalClientHeadPositionForm';
import {
  parseAddressValue,
  parseTaxResidencesValue,
  parsePepConnectionInitialValue,
  parseResidentialAddressValue,
  parseIdentityDocumentWithFilesInitialValue,
  parseCitizenshipsValue,
} from 'modules/client/common/helpers';

import { LegalClientFirstHeadFormType } from '../../forms/legalClientFirstHeadForm';

export const getLegalClientFirstHeadInitialValue = (
  client: LegalClientFirstHeadEntity,
  t: TFunc
): LegalClientFirstHeadFormType => ({
  contacts: {
    email: client.email,
  },

  reasonChange: { reason: '' },

  personalData: {
    firstName: client.firstName,
    lastName: client.lastName,
    middleName: client.middleName ?? '',
    dateOfBirth: client.dateOfBirth,
  },

  citizenships: parseCitizenshipsValue(client.citizenships),

  taxResidences: parseTaxResidencesValue(client.taxResidences),

  registrationAddress: parseAddressValue(client.registrationAddress),
  residentialAddress: parseResidentialAddressValue(client.residentialAddress),

  pepConnection: parsePepConnectionInitialValue(client.pepConnection, t),

  position: {
    headType: {
      label: t(`client.legal.legalClientHead.position.headType.person`),
      value: LegalClientHeadType.person,
    },
    dateOfExpiration: client.position?.expirationDate,
    positionConfirmationFiles: client.position?.files ?? [],
    position: client.position?.position ?? '',
  },

  activity: {
    id: client.id,
    createdAt: formatToDate(client.createdAt),
  },

  identityDocument: parseIdentityDocumentWithFilesInitialValue(
    t,
    client.identityDocument
  ),
  additionalDocumentsFiles: client.additionalInformationFiles,

  placeOfBirth: {
    country: client.placeOfBirth?.country ?? null,
    locality: client.placeOfBirth?.locality ?? '',
  },
});
